import { AxiosResponse } from "axios";
import { ErrorToast } from "../../common/toasts/toasts";
import axiosClient from "../../common/axios/axiosConfig";

interface IRequest {
  action: "start" | "stop";
}

interface IResponse {
  dateCreated: string;
  dateUpdated: string;
  roomSid: string;
  rules: Array<{ all: boolean; type: string }>;
}

export const patchRecord = async (
  roomToken: string,
  body: IRequest
): Promise<AxiosResponse<IResponse> | void> => {
  try {
    const response = await axiosClient.patch<IResponse>(
      `/room/record`,
      body,
      {
        headers: {
          Authorization: `Bearer ${roomToken}`,
        },
      }
    );
    return response;
  } catch (error: any) {
    if (error.response?.status === 403) {
      console.warn("Gravação não autorizada (403), mas fluxo segue.");
      return;
    }

    return undefined;
  }
};
